
let mbgl;
if (process.env.VUE_ENV !== 'server') {
  mbgl = require('mapbox-gl');
}

import eventHelper from '@/mixins/eventHelper'
import getMacauDateTime from '@/utils/getMacauDateTime'
import { mapState } from 'vuex'

export default {
  mixins: [eventHelper],
  data() {
    return {
      // data
      projectedSightMarkersID: null,
      projectedSightPoints: [],
      projectedSightMarkers: [],
      projectedSightMarkersSubMarkers: [],
      projectedPOISID: null,
      projectedPOIS: [],
      projectedRoute: {},
    }
  },
  computed: {
    ...mapState({
      isMobileView: state => state.ui.isMobileView,
      blackAndWhite: state => state.ui.blackAndWhite
    })
  },
  methods: {
    cleanMap: function () {
      console.log("[MAP] clean map");
      Object.keys(this.projectedRoute)
        .filter(key => this.projectedRoute[key])
        .forEach(routeKey => {
          const [group, ..._] = routeKey.split('_');
          this.removeProjectRoute({ group })
        })
      this.removeProjectedPOIS();
      this.removeProjectedSightPoints();
      this.removeProjectedSightMarkers();
    },
    mapLocaleToLabelField: function (locale) {
      switch (locale) {
        case 'ar':
        case 'de':
        case 'es':
        case 'pt':
        case 'ru':
        case 'fr':
        case 'ja':
        case 'ko':
          return `name_${locale}`;
        case 'th':
        case 'it':
        case 'ms':
        case 'id':
        case 'en':
          return 'name_en';
        case 'zh-hant':
          return 'name_zh-Hant';
        case 'zh-hans':
          return 'name_zh-Hans';
        default:
          return 'name'
      }
    },
    switchMapToGrayscale: function ({ map = null } = {}) {
      map = map || this.map;
      if (map) {
        const convertMapBoxColor = (val) => {
          if (val.startsWith('hsl')) {
            return this.hsl2Grayscale(val, true);
          } else if (val.startsWith('#')) {
            return this.hex2Grayscale(val, true)
          }

          return val;
        }

        map.getStyle().layers
          .filter(l => !!l.paint)
          .forEach(l => {
            Object.keys(l.paint)
              .filter(k => k.indexOf('color') > -1)
              .forEach(k => {
                let val = l.paint[k];
                val = Array.isArray(val)
                  ? val.map(val => typeof val == 'string' ? convertMapBoxColor(val) : val)
                  : convertMapBoxColor(val);

                map.setPaintProperty(l.id, k, val);
              })
          })
        map.getStyle().layers
          .filter(l => l.type == 'symbol' && l.paint && l.paint['text-halo-width'])
          .forEach(l => {
            map.setPaintProperty(l.id, 'text-halo-width', 0);
          })
      }
    },
    switchMapLocale: function ({ map = null, locale = null } = {}) {
      map = map || this.map;
      if (map) {
        locale = locale || this.$i18n.locale;
        const targetField = this.mapLocaleToLabelField(locale);
        console.log('[switch map locale]', map, 'to', targetField);

        const layers = map.getStyle().layers;
        if (!layers) return;

        layers
          .filter(l => l.type == 'symbol' && l.layout && l.layout['text-field'])
          .forEach(l => {
            try {
              let rawCurrentVal = map.getLayoutProperty(l.id, 'text-field');

              // Skip if rawCurrentVal is not valid
              if (!rawCurrentVal) return;

              // Handle string format (simple text-field)
              if (typeof rawCurrentVal === 'string') {
                return; // Don't modify simple string labels
              }

              const currentVal = rawCurrentVal[0] == "coalesce" ? rawCurrentVal[1] : rawCurrentVal;
              const fallbackVal = rawCurrentVal[0] == "coalesce" ? rawCurrentVal[2] : currentVal;
              let pass = false; // if use pass will not change the "ref" val to locale
              let targetVal = ['get', targetField];

              if (Array.isArray(currentVal) && currentVal[0] == 'get') {
                pass = currentVal[1] == 'ref';
              } else if (Array.isArray(currentVal) && currentVal[1] && Array.isArray(currentVal[1]) && currentVal[1][0] == 'get') {
                targetVal = ['to-string', targetVal];
                pass = currentVal[1][1] == 'ref';
              }

              // Skip 'ref' fields
              if (pass) return;

              console.log('[switch map locale] setting layer - ', l.id, rawCurrentVal);

              // Fix: Mapbox GL JS restricts "zoom" expression to top-level "step" or "interpolate".
              // If the original value (fallbackVal) contains "zoom", we cannot wrap it in "coalesce".
              const fallbackStr = JSON.stringify(fallbackVal);
              const containsZoom = fallbackStr.includes('"zoom"');
              const containsFormat = fallbackStr.includes('"format"');

              // For complex expressions (zoom, format), don't modify
              if (containsZoom || containsFormat) {
                // Try to set just the target field, with fallback to name
                map.setLayoutProperty(l.id, 'text-field', [
                  "coalesce",
                  targetVal,
                  ["get", "name_en"],
                  ["get", "name"]
                ]);
              } else {
                // Use multi-level fallback: target locale -> name_en -> name -> original
                map.setLayoutProperty(l.id, 'text-field', [
                  "coalesce",
                  targetVal,
                  ["get", "name_en"],
                  ["get", "name"],
                  fallbackVal
                ]);
              }

              console.log('[switch map locale] layer updated - ', l.id);
            } catch (e) {
              console.warn('[switch map locale] Error updating layer', l.id, e);
            }
          })
      }
    },
    _mgtoCreateMarker: function ({
      info = 0,
      icon = 'star',
      iconType = 's',
      subInfo = null,
      theme,
      active = true,
    } = {}, popupOptions = {}) {
      const markerDOM = document.createElement('a');
      markerDOM.classList.add('m-sight-marker');
      markerDOM.dataset.active = 1;
      // Ensure the <a> element covers the full marker area
      // markerDOM.style.display = 'block';
      // markerDOM.style.position = 'relative';
      markerDOM.appendChild(this._createCXMarker({
        info, icon, iconType, theme, active
      }));

      markerDOM.addEventListener('click', function (e) {
        e.stopPropagation();
        return false;
      })

      if (subInfo && (subInfo.info || subInfo.icon)) {
        const submarkerDOM = document.createElement('a');
        const cxMarker = this._createCXMarker({
          ...subInfo, theme
        });
        cxMarker.className += " sm";
        submarkerDOM.appendChild(cxMarker);
        submarkerDOM.classList.add('m-subsight-marker--bunlde');
        markerDOM.appendChild(submarkerDOM);
      }
      const marker = new mbgl.Marker(markerDOM);

      let { thumbnail, title, subtitle, description, to } = popupOptions;
      if (thumbnail || title || subtitle || description) {
        let popupHtml = this.createPOIPopup(popupOptions);
        let popup = new mbgl.Popup({
          closeButton: false,
          className: 'm-popup',
          anchor: 'bottom',
          offset: subInfo ? [10, -10] : 10
        }).setDOMContent(popupHtml);
        marker.setPopup(popup);
        this._bindPopupHoverToMarker(marker, popupHtml);
      }

      return marker;
    },
    _flattenCoordinates: function (coordinates) {
      return coordinates.reduce((acc, val) => {
        return Array.isArray(val[0])
          ? acc.concat(this._flattenCoordinates(val))
          : acc.concat([val])
      }, [])
    },
    sightHasGI: function (sight) {
      return (sight.coordinate && sight.coordinate.length > 0)
        || (sight.subsights
          && sight.subsights.length > 0
          && sight.subsights.some(s => s.coordinate && s.coordinate.length > 0))
    },
    flyToSight: function ({ sight = {}, zoom = 12.5 }) {
      let coordinates = sight.coordinate ? sight.coordinate : [];
      let { subsights = [] } = sight;
      const subcoordinates = subsights.reduce((acc, val) => {
        return (val.coordinate && val.coordinate.length > 0)
          ? acc.concat([val.coordinate])
          : acc
      }, []);
      if (subcoordinates.length > 0) {
        coordinates = [coordinates, ...subcoordinates];
      }

      if (coordinates.length == 0) return;

      this.flyTo({
        center: coordinates,
        zoom
      })
    },
    flyTo: function ({ map = null, center = [113.558, 22.163], zoom = 12.5, animate = true }) {
      map = map || this.map;
      if (!map) return;

      console.log('[MAP] Fly To:', { center, zoom });
      if (!center || !Array.isArray(center)) return;
      center = center.filter(c => c && (!Array.isArray(c) || (Array.isArray(c) && c.length > 0)));
      if (center.length == 0) return;

      if (!Array.isArray(center[0])) {
        map.flyTo({ center, zoom, animate });
      } else {
        center = this._flattenCoordinates(center);
        const bounds = new mbgl.LngLatBounds();
        center.filter(p => p.length == 2).forEach(p => bounds.extend(p));
        map.fitBounds(bounds,
          this.isMobileView
            ? { padding: 50, maxZoom: 20, animate }
            : { padding: 100, maxZoom: 16, animate }
        )
      }
    },
    resizeMap: function () {
      // Seen like don't need to call resize funciton manually
      this.map && this.map.resize();
      console.log("[MAP] Map Resize");
    },
    /**
     * Display zoom level for testing
     */
    displayZoomLevel: function ({ map = null } = {}) {
      map = map || this.map;
      if (!map) return;

      // Create zoom level display element
      const zoomDisplay = document.createElement('div');
      zoomDisplay.id = 'map-zoom-display';
      zoomDisplay.style.cssText = `
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(255, 0, 0, 0.9);
        color: white;
        padding: 8px 12px;
        border-radius: 4px;
        font-family: monospace;
        font-size: 14px;
        font-weight: bold;
        z-index: 99999;
        pointer-events: none;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      `;

      // Update zoom level display
      const updateZoomDisplay = () => {
        const zoom = map.getZoom().toFixed(2);
        zoomDisplay.textContent = `Zoom: ${zoom}`;
      };

      // Initial display
      updateZoomDisplay();

      // Add to map container
      map.getContainer().appendChild(zoomDisplay);

      // Update on zoom change
      map.on('zoom', updateZoomDisplay);
      map.on('zoomend', updateZoomDisplay);

      console.log('[MAP] Zoom level display enabled');
    },
    /**
     * Remove zoom level display
     */
    removeZoomLevelDisplay: function ({ map = null } = {}) {
      map = map || this.map;
      if (!map) return;

      const zoomDisplay = map.getContainer().querySelector('#map-zoom-display');
      if (zoomDisplay) {
        zoomDisplay.remove();
        console.log('[MAP] Zoom level display removed');
      }
    },
    /**
     * Create CX marker
     */
    _createCXMarker: function ({
      info = 0,
      icon = 'star',
      iconType = 's',
      theme,
      themeClass,
      active = false
    }) {
      const markerDOM = document.createElement('div');
      markerDOM.className = active ? 'cx-marker' : 'cx-icon';
      // Prevent child elements from capturing mouse events - let parent handle them
      markerDOM.style.pointerEvents = 'none';
      if (themeClass
        && themeClass.active
        && themeClass.dismiss
      ) {
        markerDOM.classList.add(themeClass.dismiss)
      } else {
        markerDOM.style.color = this.colorParser(theme);
      }
      markerDOM.innerHTML = `<span class="cx-marker__info">${info ? info
        : `<i class="fa${iconType} fa-${icon}"></i>`
        }</span>`;
      return markerDOM;
    },
    /**
     * Project Route - will remove other active map
     * Need map to be init-ed
     */
    projectRoute: function ({ group, route, theme, pendingForMap = false }) {
      const layerID = `${group}_route`;

      if (!pendingForMap) {
        this.projectedRoute[layerID] = true;
        // remove other active route
        Object.keys(this.projectedRoute)
          .filter(id => id != layerID)
          .forEach(id => {
            this.projectedRoute[id] && this.removeProjectRoute({ groud: id });
          })
      }


      console.log('[MAP] Project route state', {
        layerID,
        projectedRoute: this.projectRoute,
      });
      if (this.loading) {
        setTimeout(() => {
          this.projectRoute({ group, route, theme, pendingForMap: true });
        }, 500);
        return;
      }
      if (pendingForMap && !this.projectedRoute[layerID]) {
        console.log('[MAP] Project route (CANCEL)', { route });

        return;
      }

      console.log('[MAP] Project route', { route }, theme);
      if (this.map && this.map.getLayer(layerID)) {
        this.map.setLayoutProperty(`${group}_route`, 'visibility', 'visible');
        return;
      }
      this.map.addLayer({
        id: layerID,
        type: "line",
        source: {
          type: "geojson",
          data: {
            "type": "Feature",
            "geometry": {
              "type": "LineString",
              "coordinates": route
            }
          }
        },
        layout: {
          "line-join": "round",
          "line-cap": "round"
        },
        paint: {
          "line-color": this.colorParser(theme),
          "line-width": 3
        }
      })
    },
    removeProjectRoute: function ({ group }) {
      const layerID = `${group}_route`;
      this.projectedRoute[layerID] = false;
      console.log('[MAP] Remove project route', {
        layerID,
        projectRoute: this.projectRoute
      });
      if (this.loading) return;

      if (group) {
        if (this.map && !this.map.getLayer(layerID)) return;
        this.map && this.map.setLayoutProperty(layerID, 'visibility', 'none');
      } else {
        // remove all projected route
        Object.keys(this.projectedRoute).forEach(id => {
          this.projectedRoute[id] = false;
        })

        let layers = this.map.isStyleLoaded() && this.map.getStyle().layers;
        if (Array.isArray(layers)) {
          layers.forEach(({ id }) => id.endsWith('_route') && this.map && this.map.setLayoutProperty(id, 'visibility', 'none'))
        }
      }
    },
    /**
     * Project Sights as Points
     */
    projectSightsAsPoint: function ({ sights, theme, isOriginal = true }) {
      isOriginal && console.log(`[MAP] Project Sight as Point Called, ${sights.length} sights with color ${theme}`);
      sights.forEach(sight => {
        if (sight.length == 0) return;
        if (Array.isArray(sight[0])) {
          this.projectSightsAsPoint({
            sights: sight,
            theme,
            isOriginal: false
          })
        } else {
          const markerDOM = document.createElement('div');
          markerDOM.className = 'map-marker--point'
          if (theme) {
            markerDOM.style.cssText = `background-color: ${this.colorParser(theme)}`
          }
          const marker = new mbgl.Marker(markerDOM)
            .setLngLat(sight)
            .addTo(this.map);
          this.projectedSightPoints.push(marker);
        }
      });
    },
    removeProjectedSightPoints: function () {
      console.log('[MAP] Remove Projected Sights');
      while (this.projectedSightPoints.length > 0) {
        const sight = this.projectedSightPoints.pop();
        sight.remove();
      }
    },
    /**
     * Project Sights as Marker
     */
    projectSightsAsMarker: function ({ projectID, sights, theme, options: { to = '', withQueryString = false, addDescToPopup = false } = {}, startIdx = 0, preservePopup = false, isWhatson = false }) {
      console.log('[MAP] Project Sight as Marker Called', {
        projectID,
        length: sights.length,
        sightsDetail: sights,
        theme
      });

      if (projectID == this.projectedSightMarkersID) {
        return;
      } else if (this.projectedSightMarkersID != null) {
        this.removeProjectedSightMarkers();
      }
      const _projectMarker = ({
        idx, id, name, thumbnail, coordinate, cuisine, star, description = ''
      } = {},
        themeClass, sidx = '', subsightDetail = null
      ) => {
        const vm = this;
        const markerDOM = document.createElement('a');
        const mediaHost = isWhatson ? 'WHATSON' : 'MGTO';
        markerDOM.classList.add('m-sight-marker');
        markerDOM.title = name || '';
        markerDOM.dataset.id = idx;
        markerDOM.dataset.sidx = sidx;
        markerDOM.dataset.description = description;
        markerDOM.dataset.lng = coordinate[0];
        markerDOM.dataset.lat = coordinate[1];
        markerDOM.dataset.theme = theme;
        markerDOM.dataset.mediaHost = mediaHost;
        if (themeClass && themeClass.active && themeClass.dismiss) {
          markerDOM.dataset.activeClass = themeClass.active;
          markerDOM.dataset.dismissClass = themeClass.dismiss;
        }
        if (subsightDetail) {
          if (!subsightDetail.thumbnail
            && subsightDetail.infos
            && subsightDetail.infos.venue
            && subsightDetail.infos.venue.name
          ) {
            subsightDetail = subsightDetail.infos.venue;
          }
          markerDOM.dataset.ssThumbnail = subsightDetail.thumbnail || '';
          markerDOM.dataset.ssName = subsightDetail.name || '';
          let url = this.getExperienceSightLink(subsightDetail);
          if (url) markerDOM.dataset.ssLink = `/${this.$i18n.locale}${url}`
        }
        markerDOM.dataset.active = 0;
        markerDOM.appendChild(this._createCXMarker({ info: idx, theme, themeClass }));
        let popupHtml = this.createPOIPopup({
          thumbnail,
          title: name,
          description: (cuisine && false)
            ? `<span class="cx-link__icon">
                <i class="far fa-utensils"></i>
              </span>
              <span>${cuisine.name}</span>`
            : (star && (star.value ? false : true)
              ? `<span class="cx-link__icon">
                  <i class="far fa-star"></i>
                </span>
                <span>${star}</span>`
              : description
            ),
          mediaHost,
          to: isWhatson && to ? `/${this.$i18n.locale}${to}${id}` : null,
        });
        let popup = new mbgl.Popup({
          closeButton: false,
          className: 'm-popup'
        }).setDOMContent(popupHtml);
        let marker = new mbgl.Marker(markerDOM)
          .setLngLat(coordinate)
          .setPopup(popup)
          .addTo(this.map);

        markerDOM.togglePopup = function () { marker.togglePopup(); };
        markerDOM.popup = undefined;

        markerDOM.addEventListener('click', function (e) {
          e.stopPropagation();
          return false;
        })

        markerDOM.addEventListener(
          /MSIE/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)
            ? 'mouseleave'
            : 'mouseenter'
          , function (e) {
            // Skip rerender if popup timer is running - fixes Chrome hover issue
            var popup = markerDOM.popup || (marker && marker.getPopup && marker.getPopup());
            if (popup && popup.openCounter != null) {
              return;
            }
            vm.rerenderProjectedMarker(markerDOM.dataset.id, preservePopup)
          })

        this._bindPopupHoverToMarker(marker, popupHtml, true);

        // add reference
        this.projectedSightMarkers.push(marker);

        // binding event
        if (to && id) {
          markerDOM.addEventListener('click', function () {
            vm.$router.push(to + id + (withQueryString ? `?${vm.getQueryString()}` : ''));
          });
        }
      }
      // startIdx = parseInt(startIdx, 10) || 0;

      this.$nextTick(() => {
        sights.map((s, idx) => {
          return { ...s, idx: (s.idx || (startIdx + idx)) + 1 }
        }).sort(({ coordinate: a }, { coordinate: b }) => {
          if (!a || !b) return 0;
          if (a[1] == b[1]) return 0;
          return a[1] > b[1] ? -1 : 1;
        }).forEach(sight => {
          let {
            idx, id, name, thumbnail, coordinate, subsights,
            infos,
            cuisine, // hotel, restaurant
            star, // hotels,
            dateStatus, daysBeforeStart, daysBeforeEnd, // events
          } = sight;
          let description = infos ? (infos.description || infos.address) : undefined;

          let themeClass = {};
          if (dateStatus) {
            let status = this.getWhatsonDateStatusClass({
              dateStatus,
              daysBeforeStart,
              daysBeforeEnd
            });

            switch (status) {
              case 'date-status--ending':
                themeClass.dismiss = 'color--red';
                themeClass.active = 'bg--red'
                break;

              case 'date-status--inprogress':
                themeClass.dismiss = 'color--yellow';
                themeClass.active = 'bg--yellow'
                break;

              case 'date-status--upcoming':
              case 'date-status--starting':
                themeClass.dismiss = 'color--green';
                themeClass.active = 'bg--green'
                break;

              case 'date-status--ended':
                themeClass.dismiss = 'outdated-marker';
                themeClass.active = 'bg--midgrey'
                break;

              default:
                if (dateStatus == 'fullMonth') {
                  themeClass.dismiss = 'color--cyan';
                  themeClass.active = 'bg--cyan'
                }
                break;
            }
          }

          if (!coordinate || coordinate.length == 0) {
            if (!subsights || subsights.length == 0) {
              return;
            } else {
              coordinate = subsights.map(s => s.coordinate || [])
            }
          }

          if (!Array.isArray(coordinate[0])) {
            _projectMarker({ idx, id, name, thumbnail, coordinate, cuisine, star, description }, themeClass)
          } else {
            coordinate.forEach((c, sidx) => _projectMarker(
              {
                idx, id, name, thumbnail,
                coordinate: c, cuisine, star,
                description: (addDescToPopup && subsights && subsights[sidx] && subsights[sidx].description) || undefined
              }, themeClass, String.fromCharCode(65 + sidx),
              (subsights && subsights[sidx]) || null
            ))
          }
        });
        this.projectedSightMarkersID = projectID;
      })
    },
    rerenderProjectedActiveMarker: function ({ id, preservePopup } = {}) {
      if (!id) {
        let activeMarker = this.projectedSightMarkers.find(m => {
          return m.getElement().dataset.active == 1
        });

        if (activeMarker) {
          id = activeMarker.getElement().dataset.id;
        }
      }

      if (id) {
        this.dismissProjectedMarker({ id });
        this.activeProjectedMarker({ id, preservePopup });
      }
    },
    rerenderProjectedMarker: function (id, preservePopup) {
      let targets = this.projectedSightMarkers.filter(m => {
        return m.getElement().dataset.id == id
      });

      if (targets.length) {
        if (targets[0].getElement().dataset.active == 1) {
          // this.dismissProjectedMarker({id});
          // this.activeProjectedMarker({id,preservePopup});
          this.rerenderProjectedActiveMarker({ id, preservePopup });
        } else {
          targets.forEach(m => {
            m.remove();
            m.addTo(this.map);
          })
          this.rerenderProjectedActiveMarker();
        }
      }
    },
    // TODO: should be sysnc?
    removeProjectedSightMarkers: function () {
      while (this.projectedSightMarkers.length > 0) {
        const sight = this.projectedSightMarkers.pop();
        sight.remove();
      }
      this.removeProjectedSightMarkersSubMarkers();
      this.projectedSightMarkersID = null;
    },
    removeProjectedSightMarkersSubMarkers: function () {
      while (this.projectedSightMarkersSubMarkers.length > 0) {
        const sight = this.projectedSightMarkersSubMarkers.pop();
        sight.remove();
      }
    },
    activeProjectedMarker: function ({ id, dismissOtherActive = true, preservePopup = false }) {
      console.log(`[MAP] Active Marker with id: ${id}`);
      dismissOtherActive && this.projectedSightMarkers.filter(m => {
        return m.getElement().dataset.id != id && m.getElement().dataset.active == 1
      }).forEach(m => {
        this.dismissProjectedMarker({ id: m.getElement().dataset.id });
      })

      this.projectedSightMarkers.filter(m => {
        return m.getElement().dataset.id == id && m.getElement().dataset.active == 0
      }).forEach(m => {
        let markerDOM = m.getElement();
        let popup = m.getPopup();
        let { lng, lat, theme, sidx, activeClass, dismissClass } = markerDOM.dataset;
        markerDOM.dataset.active = 1;
        markerDOM.firstChild.className = 'cx-marker';
        if (activeClass) {
          markerDOM.firstChild.classList.add(activeClass)
          markerDOM.firstChild.classList.remove(dismissClass)
        } else {
          markerDOM.firstChild.style.color = '';
          markerDOM.firstChild.style.backgroundColor = this.colorParser(theme);
        }
        m.remove();
        m = new mbgl.Marker(markerDOM, { anchor: 'bottom' })
          .setLngLat([lng, lat])
          .setPopup(popup)
          .addTo(this.map)

        // Always allow the main popup to be toggled - this fixes Chrome hover issue
        // where the timer completes but popup wouldn't open because togglePopup was empty
        markerDOM.togglePopup = function () { m.togglePopup(); };
        if (preservePopup) {
          markerDOM.removeAttribute('title');
          markerDOM.style.setProperty('cursor', 'pointer');
        }
        markerDOM.popup = popup;
        if (sidx) {
          const submarkerDOM = document.createElement('a');
          const cxMarker = this._createCXMarker({
            info: sidx, theme, themeClass: {
              active: activeClass,
              dismiss: dismissClass
            }
          });
          cxMarker.className += " sm";
          submarkerDOM.appendChild(cxMarker);
          submarkerDOM.classList.add('m-subsight-marker');

          let subm = new mbgl.Marker(submarkerDOM, { anchor: 'bottom', offset: [10, -30] })
            .setLngLat([lng, lat])

          if (markerDOM.dataset.ssName) {
            let popupHtml = this.createPOIPopup({
              thumbnail: markerDOM.dataset.ssThumbnail || '',
              title: markerDOM.dataset.ssName,
              to: markerDOM.dataset.ssLink || '',
              description: markerDOM.dataset.description || '',
              mediaHost: 'MGTO'//markerDOM.dataset.mediaHost
            });

            let popup = new mbgl.Popup({
              closeButton: false,
              className: 'm-popup',
              anchor: 'bottom',
              offset: [10, -30]
            }).setDOMContent(popupHtml);

            subm.setPopup(popup);
            this._bindPopupHoverToMarker(subm, popupHtml);
            markerDOM.togglePopup = function () { subm.togglePopup(); };
            markerDOM.popup = popup;
          }
          subm.addTo(this.map)
          this.projectedSightMarkersSubMarkers.push(subm);
        }
      })
    },
    dismissProjectedMarker: function ({ id }) {
      console.log(`[MAP] Dismiss Marker with id: ${id}`);
      this.removeProjectedSightMarkersSubMarkers();
      this.projectedSightMarkers.filter(m => {
        return m.getElement().dataset.id == id && m.getElement().dataset.active == 1
      }).forEach(m => {
        let markerDOM = m.getElement();
        let popup = m.getPopup();
        let { lng, lat, theme } = markerDOM.dataset;
        markerDOM.dataset.active = 0;
        markerDOM.firstChild.className = 'cx-icon';
        if (markerDOM.dataset.activeClass) {
          markerDOM.firstChild.classList.remove(markerDOM.dataset.activeClass)
          markerDOM.firstChild.classList.add(markerDOM.dataset.dismissClass)
        } else {
          markerDOM.firstChild.style.color = this.colorParser(theme);
          markerDOM.firstChild.style.backgroundColor = '';
        }
        m.remove();
        m = new mbgl.Marker(markerDOM)
          .setLngLat([lng, lat])
          .setPopup(popup)
          .addTo(this.map)
        markerDOM.togglePopup = function () { m.togglePopup(); };
        markerDOM.popup = undefined;
      })
    },
    _createPOIMarker: function ({ type, distance, id }, icon, theme) {
      const markerDOM = document.createElement('span');
      markerDOM.dataset.type = type;
      markerDOM.dataset.distance = distance;
      markerDOM.dataset.id = id;
      markerDOM.className = 'cx-icon--sm m-poi-marker';
      markerDOM.style.color = '';
      markerDOM.style.backgroundColor = this.colorParser(theme);
      markerDOM.innerHTML = `
        <span class="cx-marker__info">
          <i class="fas fa-${icon}"></i>
        </span>`;
      return markerDOM;
    },
    createPOIPopup: function ({ thumbnail, title, subtitle, description, to, mediaHost = 'MGTO' }) {
      const isWhatson = mediaHost == 'WHATSON';

      const wrapTo = (innerHTML) => {
        if (!to || !innerHTML) {
          return innerHTML;
        }

        if (to.startsWith('http')) {
          return `<a href="${to}">${innerHTML}</a>`
        }

        return `<a class="cx-internal-link" data-internal-href="${to}" href="${to}">${innerHTML}</a>`
      }

      let thumbnailHTML = wrapTo(thumbnail ? `
        <div class="cx-media--cover">
          <div class="cx-media__img"
            style="background-image: url(${this.parseImg(
        this.getMediaHost(thumbnail, mediaHost).toString(),
        { faceFocus: isWhatson }
      )}"
          ></div>
        </div>
      `: "");

      let titleHTML = wrapTo(title ? `
        <div class="cx-t20">
          ${title}
        </div>
      `: "");

      let subtitleHTML = subtitle ? `
        <div class="cx-t10">
          ${subtitle}
        </div>
      `: ""

      let headerHTML = (titleHTML || subtitleHTML) ? `
        <div>
          ${subtitleHTML}
          ${titleHTML}
        </div>
      `: "";

      let descriptionHTML = description ? `
        <div class="-fade cx-t01">
          <p>
            ${description}
          </p>
        </div>
      ` : "";

      const articleDOM = document.createElement("div");
      articleDOM.innerHTML = `
        <article>
          <div class="cx-wrap">
            ${headerHTML}
            ${descriptionHTML}
          </div>
          ${thumbnailHTML}
        </article>
      `

      let internalLinks = [].slice.call(articleDOM.querySelectorAll('a[data-internal-href]'));
      let vm = this;

      internalLinks.length > 0 && internalLinks.forEach((link) => {
        let routingLink = link.dataset.internalHref;
        link.href = this.localedURL(routingLink)
        link.addEventListener('click', function (e) {
          e.preventDefault();
          vm.$router.push(routingLink);
        })
      })

      articleDOM.className = "popup-wrapper";
      return articleDOM;
    },
    projectPOIS: function ({ projectID, pois, least = false, redo = false, sights = [], sightIds = [], sightCoordinates = [] }) {
      if (!pois || pois.length === 0) {
        return;
      }
      if (!least) {
        if (!redo && projectID == this.projectedPOISID) {
          return;
        }
        this.removeProjectedPOIS();
        sights.forEach(s => {
          sightIds.push(s.id)
          sightCoordinates.push((Math.floor(Number.parseFloat(s.coordinate[0]) * 10000000000) / 10000000000).toFixed(10) + ' ' + (Math.floor(Number.parseFloat(s.coordinate[1] * 10000000000)) / 10000000000).toFixed(10))
        })
        // sights in current group is not a poi
        // e.g., sights in group "macao-world-heritage": http://localhost:8080/api/experience/sightseeing/macao-world-heritage?lang=zh-hant
        pois = pois.filter(poi => {
          return !sightIds.includes(poi.id)
        })
      }

      console.log('[MAP] Project POIS', { pois });
      const sizeToRenderPerTurn = 5;
      const toRender = pois.slice(0, sizeToRenderPerTurn);
      const toLeast = pois.slice(sizeToRenderPerTurn, pois.length);

      const getTmpClosedText = p => {
        const span = '<span> (' + this.$t('common.tempClosedToPublic') + ')</span>';
        if (typeof (p.tempClose || p.tempClosed) === 'boolean') {
          return (p.tempClose || p.tempClosed) ? span : '';
        }
        let tmpClosed = !p.tmpCloseStart && !p.tmpCloseEnd ? '' : span;
        if (tmpClosed) {
          const current = getMacauDateTime();
          const tmpCloseStart = p.tmpCloseStart && getMacauDateTime(p.tmpCloseStart);
          const tmpCloseEnd = p.tmpCloseEnd && getMacauDateTime(p.tmpCloseEnd);
          if (tmpCloseStart && tmpCloseEnd) {
            if (current > tmpCloseStart && current < tmpCloseEnd) { } else {
              tmpClosed = '';
            }
          } else {
            // https://3.basecamp.com/3633946/buckets/6317965/todos/5925318504#__recording_5936767540
            const logic1 = tmpCloseStart ? current > tmpCloseStart : true;
            const logic2 = tmpCloseEnd ? current < tmpCloseEnd : true;
            if (logic1 && logic2) { } else {
              tmpClosed = '';
            }
          }
        }
        return tmpClosed;
      };

      toRender.forEach((p, idx) => {
        const dataset = { type: p.type, distance: p.distance, id: p.id };
        let markerDOM, popupHtml;

        if (p.type === 'whatson') {
          // ref: https://3.basecamp.com/3633946/buckets/6317965/messages/4305436588#__recording_4524603952
          const checkAvailability = (dates = []) => {
            if (dates.length === 0) {
              return true;
            }
            if (Date.now() < new Date(dates[dates.length - 1][1])) {
              return true;
            }
            // const current = getMacauDateTime();
            // return dates.find(date => {
            //   const [from, to] = date;
            //   const fromDate = getMacauDateTime(`${from} 00:00:00`);
            //   const toDate = getMacauDateTime(`${to} 23:59:59`);
            //   return current > fromDate && current < toDate;
            // });
            return false
          };
          if (checkAvailability(p.eventDateRange)) {
            const description = [
              p.types && p.types.length > 0 ? `<span><i class="fal fa-tag"></i></span> ${p.types.map(t => t.name).join(', ')}` : undefined,
              `<span><i class="fal fa-calendar"></i></span> <span><b>${p.showDate}</b></span>`,
            ].join('<br />');
            markerDOM = this._createPOIMarker(dataset, 'calendar-star', '#5b3b8c');
            popupHtml = this.createPOIPopup({
              thumbnail: p.thumbnail,
              title: `${p.name}`,
              description,
              to: `/${this.$i18n.locale}/events/whatson/${p.id}`,
              mediaHost: 'WHATSON',
            });
          }
        }
        if (p.type === 'freewifi') {
          const description = [
            `<span>${p.info}</span>`,
            `<span>${this.$t('common.ssid') || 'SSID'}: ${p.ssid}</span>`,
            p.password ? `<span>${this.$t('common.password') || 'Password'}: ${p.password}</span>` : undefined,
          ].join('<br />');
          markerDOM = this._createPOIMarker(dataset, 'wifi', '#28bf8f');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description,
            to: `http://freewifi.mo/cn/search/${p.id}/map`
          });
        }
        if (p.type === 'sightseeing') {
          const icon = 'camera';
          markerDOM = this._createPOIMarker(dataset, icon, '#008a28');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description: p.group ? `<span>${p.group.name || ''}</span>` : undefined,
            to: `/${this.$i18n.locale}/sight/${p.id}`
          });
        }
        if (p.type === 'shows-and-entertainment') {
          const icon = 'theater-masks';
          markerDOM = this._createPOIMarker(dataset, icon, '#008a28');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description: p.group ? `<span>${p.group.name || ''}</span>` : undefined,
            to: `/${this.$i18n.locale}/sight/${p.id}`
          });
        }
        if (p.type === 'shopping') {
          const icon = 'shopping-bag';
          markerDOM = this._createPOIMarker(dataset, icon, '#008a28');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description: p.group ? `<span>${p.group.name || ''}</span>` : undefined,
            to: `/${this.$i18n.locale}/sight/${p.id}`
          });
        }
        if (p.type === 'hotel') {
          markerDOM = this._createPOIMarker(dataset, 'heading', '#44b3e2');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description: '<span class="cx-link__icon"><i class="far fa-star"></i></span> <span>' + p.star + '</span>',
            to: `/${this.$i18n.locale}/accommodation/${p.id}`
          });
        }
        if (p.type === 'lrt') {
          markerDOM = this._createPOIMarker(dataset, 'train-subway', '#4c3dfe');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description: '<span class="cx-link__icon"><i class="far fa-route"></i></span> <span>' + p.route + '</span>',
            to: p.link
          });
        }
        if (p.type === 'fnb') {
          markerDOM = this._createPOIMarker(dataset, 'utensils', '#ff3d4d');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description: '<span class="cx-link__icon"><i class="far fa-utensils"></i></span> <span>' + p.group.name + '</span>',
            // to: `/${this.$i18n.locale}/dining/macao-classic-brand-and-distinctive-shops/${p.group.value}/${p.id}`
            to: `/${this.$i18n.locale}/dining/specialty-foods/${p.group.value}/${p.id}`
          });
        }
        if (p.type === 'restaurant') {
          markerDOM = this._createPOIMarker(dataset, 'utensils', '#f7931e');
          popupHtml = this.createPOIPopup({
            thumbnail: p.thumbnail,
            title: `${p.name}`,
            description: (p.cuisine && false) ? '<span class="cx-link__icon"><i class="far fa-utensils"></i></span> <span>' + p.cuisine + '</span>' : '',
            to: `/${this.$i18n.locale}/dining/qtsas-restaurant/${p.id}`
          });
        }
        if (p.type === 'drink') {
          let thumbnail = p.photos && p.photos.length > 0 ? p.photos[0] : undefined;
          let tmpClosed = getTmpClosedText(p);
          const description = [
            '<span class="cx-link__icon"><i class="far fa-clock"></i></span> ' + p.openingHour + tmpClosed,
          ];
          if (p.address) {
            description.push(this.$t('common.address') + ': <span>' + p.address + '</span>');
          }
          if (p.tel) {
            description.push(this.$t('common.tel') + ': <span>' + p.tel + '</span>');
          }
          markerDOM = this._createPOIMarker(dataset, 'droplet', '#6898dd');
          popupHtml = this.createPOIPopup({
            thumbnail,
            title: this.$t('common.drink'),
            description: description.join('<br />'),
          });
        }
        if (p.type === 'nursingroom') {
          let thumbnail = p.photos && p.photos.length > 0 ? p.photos[0] : undefined;
          let tmpClosed = getTmpClosedText(p);
          const description = [
            '<span class="cx-link__icon"><i class="far fa-clock"></i></span> ' + p.openingHour + tmpClosed,
          ];
          if (p.address) {
            description.push(this.$t('common.address') + ': <span>' + p.address + '</span>');
          }
          if (p.tel) {
            description.push(this.$t('common.tel') + ': <span>' + p.tel + '</span>');
          }
          markerDOM = this._createPOIMarker(dataset, 'person-breastfeeding', '#db9ee7');
          popupHtml = this.createPOIPopup({
            thumbnail,
            title: this.$t('common.nursingroom'),
            description: description.join('<br />'),
          });
        }
        if (p.type === 'publictoilet') {
          let thumbnail = p.photos && p.photos.length > 0 ? p.photos[0] : undefined;
          let tmpClosed = getTmpClosedText(p);
          const description = [
            '<span class="cx-link__icon"><i class="far fa-clock"></i></span> ' + p.openingHour + tmpClosed,
          ];
          if (p.address) {
            description.push(this.$t('common.address') + ': <span>' + p.address + '</span>');
          }
          if (p.tel) {
            description.push(this.$t('common.tel') + ': <span>' + p.tel + '</span>');
          }
          markerDOM = this._createPOIMarker(dataset, 'restroom-simple', '#4c4c44');
          popupHtml = this.createPOIPopup({
            thumbnail,
            title: this.$t('common.publicToilet'),
            description: description.join('<br />'),
          });
        }
        if (p.type === 'busstop') {
          markerDOM = this._createPOIMarker(dataset, 'bus', '#286ebf');
          popupHtml = this.createPOIPopup({
            title: `${p.id} - ${p.name}`,
            description: '<span class="cx-link__icon"><i class="far fa-bus"></i></span> <span>' + p.routes + '</span>'
          });
        }
        if (p.type === 'touristinfo') {
          markerDOM = this._createPOIMarker(dataset, 'info', '#ed408d');
          popupHtml = this.createPOIPopup({
            title: p.name,
            subtitle: this.$t('common.touristInfomation'),
            description: '<span class="cx-link__icon"><i class="far fa-clock"></i></span> <span>' + p.openingHour + '</span>'
          });
        }

        let popup, marker;

        if (popupHtml) {
          popup = new mbgl.Popup({
            closeButton: false,
            offset: -1,
            className: 'm-popup'
          }).setDOMContent(popupHtml);
        }
        if (markerDOM) {
          // p.coordinate may be an array of coordinates
          if (Array.isArray(p.coordinate[0])) {
            marker = new mbgl.Marker(markerDOM).setLngLat(p._nearestCoordinate || p.coordinate[0]);
          } else {
            marker = new mbgl.Marker(markerDOM).setLngLat(p.coordinate);
          }
          if (popup) {
            marker.setPopup(popup);
          }
          if (!this.isMobileView) {
            markerDOM.addEventListener('click', function (e) {
              e.stopPropagation();
              return false;
            })
          }
        }
        if (marker) {
          popupHtml && this._bindPopupHoverToMarker(marker, popupHtml);

          this.poisToShow[p.type] && p.distance <= this.range && marker.addTo(this.map);
          this.projectedPOIS.push(marker);
        }
      });

      if (toLeast.length > 0) {
        this.$nextTick(() => {
          this.projectPOIS({ projectID, pois: toLeast, least: true, sights, sightIds, sightCoordinates });
        });
      } else {
        this.rerenderProjectedActiveMarker();
      }
      if (!least) {
        this.projectedPOISID = projectID;
      }
    },
    removeProjectedPOIS: function () {
      console.log('[MAP] Remove POIS', { pois: this.projectedPOIS });
      while (this.projectedPOIS.length > 0) {
        let marker = this.projectedPOIS.pop();
        marker.remove();
      }
      this.projectedPOISID = null;
    },

    /**
     * Reposition to project object
     *
     * POIS -> Marker
     */
    repositionToProjectedObjects: function (coordinates) {
      if (coordinates) {
        return this.flyTo({ center: coordinates })
      }

      const center = [];
      const extractCoordinateFromMarker = m =>
        center.push(m.getLngLat ? m.getLngLat().toArray() : [113.558, 22.163]);

      // POIS only display when a marker is active
      if (this.projectedPOIS.length > 0) {
        this.projectedPOIS.forEach(extractCoordinateFromMarker)

        this.projectedSightMarkers
          // filter active marker
          .filter(m => m.getElement().dataset.active == 1)
          .forEach(extractCoordinateFromMarker)
      } else {
        this.projectedSightMarkers.forEach(extractCoordinateFromMarker)
      }

      this.flyTo({ center })
    },
    _bindPopupHoverToMarker: function (marker, popupDOM, toggleOnMarkerDOM = false) {
      const markerDOM = marker.getElement();
      const toggleObject = toggleOnMarkerDOM ? markerDOM : marker;

      // Helper to close all other popups before opening a new one
      const closeAllOtherPopups = () => {
        document.querySelectorAll('.mapboxgl-popup').forEach(el => {
          // Check if this is NOT the popup we're about to open
          const currentPopup = markerDOM.popup || marker.getPopup();
          if (!currentPopup || currentPopup._container !== el) {
            el.remove();
          }
        });
      };

      markerDOM.addEventListener('mouseenter', function () {
        let popup = markerDOM.popup || marker.getPopup();

        if (popup.closeCounter != null) {
          clearTimeout(popup.closeCounter);
          popup.closeCounter = null;
        }
        if (!popup || popup.isOpen()) return;
        // Don't reset the timer if it's already running - fixes Chrome's continuous mouseenter
        if (popup.openCounter != null) return;
        popup.openCounter = setTimeout(() => {
          if (!popup || popup.isOpen()) return;
          closeAllOtherPopups();
          toggleObject.togglePopup();
          popup.openCounter = null;
        }, 400);
      });

      markerDOM.addEventListener('mouseleave', function () {
        let popup = markerDOM.popup || marker.getPopup();

        if (popup.openCounter != null) {
          clearTimeout(popup.openCounter);
          popup.openCounter = null;
        }
        if (!popup || !popup.isOpen()) return;
        popup.closeCounter = setTimeout(() => {
          if (!popup || !popup.isOpen()) return;
          toggleObject.togglePopup();
          popup.closeCounter = null;
        }, 400);
      });

      popupDOM.addEventListener('mouseenter', function () {
        let popup = markerDOM.popup || marker.getPopup();

        if (popup.closeCounter != null) {
          clearTimeout(popup.closeCounter);
          popup.closeCounter = null;
        }
        if (!popup || popup.isOpen()) return;
        popup.openCounter = setTimeout(() => {
          if (!popup || popup.isOpen()) return;
          toggleObject.togglePopup();
          popup.openCounter = null;
        }, 400);
      });

      popupDOM.addEventListener('mouseleave', function () {
        let popup = markerDOM.popup || marker.getPopup();

        if (popup.openCounter) {
          clearTimeout(popup.openCounter);
          popup.openCounter = null;
        }
        if (!popup || !popup.isOpen()) return;
        popup.closeCounter = setTimeout(() => {
          if (!popup || !popup.isOpen()) return;
          toggleObject.togglePopup();
          popup.closeCounter = null;
        }, 400);
      });
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.switchMapLocale();
    }
  }
}
